function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentIDs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512px",
    viewBox: "0 -32 512 512",
    width: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m453.332031 64h-394.664062c-32.363281 0-58.667969 26.304688-58.667969 58.667969v266.664062c0 32.363281 26.304688 58.667969 58.667969 58.667969h394.664062c32.363281 0 58.667969-26.304688 58.667969-58.667969v-266.664062c0-32.363281-26.304688-58.667969-58.667969-58.667969zm0 0",
    fill: "#eceff1",
    "data-original": "#ECEFF1",
    className: "active-path",
    style: {
      fill: "#FFFFFF"
    },
    "data-old_color": "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 0h-96c-20.585938 0-37.332031 16.746094-37.332031 37.332031v42.667969c0 20.585938 16.746093 37.332031 37.332031 37.332031h96c20.585938 0 37.332031-16.746093 37.332031-37.332031v-42.667969c0-20.585937-16.746093-37.332031-37.332031-37.332031zm0 0",
    fill: "#607d8b",
    "data-original": "#607D8B",
    className: "",
    style: {
      fill: "#1A2838"
    },
    "data-old_color": "#607d8b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.332031 202.667969c0 29.453125-23.875 53.332031-53.332031 53.332031s-53.332031-23.878906-53.332031-53.332031c0-29.457031 23.875-53.335938 53.332031-53.335938s53.332031 23.878907 53.332031 53.335938zm0 0",
    fill: "#42a5f5",
    "data-original": "#42A5F5",
    className: "",
    "data-old_color": "#42a5f5",
    style: {
      fill: "#1A2838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.332031 277.332031h-74.664062c-32.363281 0-58.667969 26.304688-58.667969 58.667969v10.667969c0 8.832031 7.167969 16 16 16h160c8.832031 0 16-7.167969 16-16v-10.667969c0-32.363281-26.304688-58.667969-58.667969-58.667969zm0 0",
    fill: "#42a5f5",
    "data-original": "#42A5F5",
    className: "",
    "data-old_color": "#42a5f5",
    style: {
      fill: "#1A2838"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#607d8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m432 192h-117.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h117.332031c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0",
    "data-original": "#607D8B",
    className: "",
    style: {
      fill: "#1A2838"
    },
    "data-old_color": "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 277.332031h-117.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h117.332031c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0",
    "data-original": "#607D8B",
    className: "",
    style: {
      fill: "#1A2838"
    },
    "data-old_color": "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 362.667969h-117.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h117.332031c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0",
    "data-original": "#607D8B",
    className: "",
    style: {
      fill: "#1A2838"
    },
    "data-old_color": "#607D8B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIDs);
export default __webpack_public_path__ + "static/media/student-IDs.327b09f9d66bf7732e93387bcb08d3dd.svg";
export { ForwardRef as ReactComponent };